// extracted by mini-css-extract-plugin
export default {"link":"ParticipantsTable_link__P4YT+","participants-table":"ParticipantsTable_participants-table__4Wla-","row":"ParticipantsTable_row__acbi-"};